<template>
  <el-form class="supplier-form">
    <el-form-item>
      <el-table
        border
        :data="pageSupplierList"
        highlight-current-row
        header-row-class-name="table-header"
        size="medium"
      >
        <el-table-column
          label="排名"
          prop="index"
          align="center"
          type="index"
          width="60"
        />
        <el-table-column
          label="供应商名称"
          prop="supplierName"
          align="center"
          show-overflow-tooltip
          min-width="200"
        >
          <template slot-scope="{ row }">
            <span
              v-if="row.isCombo === isComboDict.YES.value"
              class="text-warning m-r-4"
            >
              联
            </span>
            <span>{{ row.supplierName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="offerTypeDict.translate(offerType).show"
          :label="`中标价(${offerTypeDict.translate(offerType).unit})`"
          align="center"
          header-align="center"
          min-width="150"
          prop="price"
        >
          <template slot-scope="{ row }">
            <template v-if="offerTypeDict.translate(offerType).unit === '元'">
              <span>{{ row.price ? strToThousands(row.price) : '-' }}</span>
              <money-in-cn :money="row.price" :show-prefix="false" />
            </template>
            <span v-else>
              <span>{{ row.price || '-' }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" width="160" label="中标通知书">
          <template slot-scope="{ row }">
            <div v-if="winnerInformType === winnerInformTypeDict.OFFLINE.value">
              {{ winnerInformTypeDict.OFFLINE.label }}
            </div>
            <div
              v-else-if="
                winnerInformType === winnerInformTypeDict.ONLINE.value ||
                  winnerInformType === winnerInformTypeDict.PLATFORM.value
              "
            >
              <upload-authorization-file
                v-if="row.noticeFileIds"
                ref="UploadAuthorizationFile"
                v-model="row.noticeFileIds"
                upload-mode="fileId"
                :preview-api="previewApi"
                :download-api="downloadApi"
                :props-data="{
                  disabled: true
                }"
                :request-params="{
                  orderId: orderId,
                  winnerId: winnerId,
                  isRelease: true,
                  supplierId: row.supplierId
                }"
              />
              <span v-else>-</span>
            </div>

            <div v-else>-</div>
          </template>
        </el-table-column>
        <!--- 代理项目 && 收取代理服务费 ------->
        <el-table-column
          v-if="
            !!Number(agentServiceFeeObj.agentServiceFee) &&
              agentServiceFeeObj.isAgency &&
              agentServiceFeeObj.agentCollectType ===
              agentCollectTypeDict.ONLINE.value
          "
          label="代理服务费支付状态"
          prop="agentFeePayStatus"
          align="center"
          min-width="180"
        >
          <template slot-scope="{ row }">
            <span>
              {{
                paymentStatusDict.translate(row.agentFeePayStatus).label || '-'
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="备注"
          prop="remark"
          align="center"
          min-width="180"
        >
          <template slot-scope="{ row }">
            <span>{{ row.remark || '-' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-if="
          winType == bidWinWayDict.SHORTLIST.value && supplierIdLists.length
        "
        :total="supplierIdLists.length"
        size="small"
        :page.sync="page"
        :limit.sync="size"
        @pagination="getPageData"
      />
    </el-form-item>
  </el-form>
</template>

<script>
// 数据字典
import {
  bidWinWayDict,
  isComboDict,
  winnerInformTypeDict
} from '@/dictionary/project/bid'
import { paymentStatusDict, offerTypeDict } from '@/dictionary/project/common'
import { agentCollectTypeDict } from '@/dictionary/company'
// 组件
import Pagination from '@/components/common/Pagination'
import MoneyInCn from '@/components/common/MoneyInCn'
import UploadAuthorizationFile from '@/components/common/Upload/UploadAuthorizationFile.vue'

import {
  previewPurchaserResultFileApi,
  downloadPurchaserResultFileApi
} from '@/api/procure/invite-bid'
// 工具方法
import { strToThousands } from '@/utils/utils'
export default {
  components: {
    Pagination,
    MoneyInCn,
    UploadAuthorizationFile
  },

  props: {
    supplierIdLists: {
      type: Array,
      default: () => []
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    winnerId: {
      type: [String, Number],
      default: ''
    },
    winType: {
      type: [String, Number],
      default: bidWinWayDict.SINGLE.value
    },
    offerType: {
      type: [String, Number],
      default: offerTypeDict.TOTAL_PRICE.value
    },
    winnerInformType: {
      type: [String, Number],
      default: ''
    },

    agentServiceFeeObj: {
      type: Object,
      default: () => ({
        agentServiceFee: '',
        isAgency: false,
        agentCollectType: false
      })
    },

    previewApi: {
      type: Function,
      default: previewPurchaserResultFileApi
    },

    downloadApi: {
      type: Function,
      default: downloadPurchaserResultFileApi
    }
  },
  data() {
    return {
      bidWinWayDict,
      offerTypeDict,
      isComboDict,
      winnerInformTypeDict,
      paymentStatusDict,
      agentCollectTypeDict,

      pageSupplierList: [],
      page: 1,
      size: 10
    }
  },
  watch: {
    supplierIdLists(val) {
      this.setSupplierPage()
    }
  },
  created() {
    this.setSupplierPage()
  },
  methods: {
    strToThousands,

    /**
     * @description: 供应商列表数据展示
     * @param {*}
     * @return {*}
     */
    setSupplierPage() {
      // 当中标方式不为入围的时候，不需要分页
      if (this.winType !== this.bidWinWayDict.SHORTLIST.value) {
        this.pageSupplierList = this.supplierIdLists
      } else {
        // 当中标方式为入围时候，需要分页
        this.getPageData()
      }
    },
    /**
     * @description: 前端分页，获取当前页数据
     * @param {*}
     * @return {*}
     */
    getPageData() {
      const start = (this.page - 1) * this.size
      const end = start + this.size
      this.pageSupplierList = this.supplierIdLists.slice(start, end)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-table {
  //font-size: pixel-to-rem($n: 18);
  th {
    line-height: 0;
  }
}
</style>
